






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';

import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import {ClientEnum} from '@/enums/client.enum';
import {TupleDictionary} from '@/utils/tupleDictionary';

import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import {VehicleTypeEnum} from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiPerfomanceTrackingPage',
  components: { ReportPowerBiContainer }
})

export default class PbiPerfomanceTrackingPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {    
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'afeb3c2f-489e-4be8-87c5-841d678ea87e' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Performance Tracking`);
  }
}
